import moment from 'moment'
import { columnHelper } from '../../../iba-components/Table'
import { TextButton } from '../../../iba-components/TextButton'

export const getColumnList = (t, deleteConfirm) => [
    columnHelper.accessor('name', {
        header: t('theme.clientTheme.column.clientThemeName'),
        size: 300
    }),
    columnHelper.accessor('created_date', {
        header: t('theme.clientTheme.column.createdDate'),
        cell: (props) => (props.getValue() ? moment(props.getValue()).format('YYYY-MM-DD') : '')
    }),
    columnHelper.accessor('create_by', {
        header: t('theme.clientTheme.column.createdBy')
    }),
    columnHelper.display({
        header: '',
        id: 'id',
        size: 30,
        cell: ({ row }) => (
            <TextButton onClick={(e) => deleteConfirm && deleteConfirm(e, row.original)}>
                {t('theme.common.delete')}
            </TextButton>
        )
    })
]
